export default {
  'storeConfig.title': '店铺配置',
  'storeConfig.form.shopName': '店铺名称',
  'storeConfig.form.shopName.placeholder': '请选择 店铺名称',
  'storeConfig.form.ccConfig': '信用卡配置',
  'storeConfig.form.ccConfig.placeholder': '请选择 信用卡配置',
  'storeConfig.form.scConfig': '续费信用卡配置',
  'storeConfig.form.scConfig.placeholder': '请选择 续费信用卡配置',
  'storeConfig.form.paypalConfig': 'PayPal配置',
  'storeConfig.form.paypalConfig.placeholder': '请选择 PayPal配置',
  'storeConfig.form.localPayment': '本地支付',
  'storeConfig.form.localPayment.placeholder': '请选择本地支付',
  'storeConfig.form.search': '查询',
  'storeConfig.form.reset': '重置',
  'storeConfig.form.collapse': '收起',
  'storeConfig.operation.attachPaymentProfile': '绑定支付信息',
  'storeConfig.operation.detachPaymentProfile': '解除支付信息',
  'storeConfig.columns.index': '#',
  'storeConfig.columns.merchantName': '商户名称',
  'storeConfig.columns.shopName': '店铺名称',
  'storeConfig.columns.shopifyId': 'Shopify ID',
  'storeConfig.columns.ccConfig': '信用卡配置',
  'storeConfig.columns.scConfig': '续费信用卡配置',
  'storeConfig.columns.paypalConfig': 'PayPal配置',
  'storeConfig.columns.localPayment': '本地支付',
  'storeConfig.columns.status': '状态',
  'storeConfig.columns.remarks': '备注',
  'storeConfig.status.enabled': '启用',
  'storeConfig.status.disabled': '禁用',
  'storeConfig.none': '无',
  'storeConfig.error.fetchFailed': '获取数据失败',
  'storeConfig.error.noSelection': '请先选择数据',
  'storeConfig.error.fetchPaymentFailed': '获取支付列表失败',
  'storeConfig.error.noMerchant': '未找到商户信息',
  'storeConfig.error.multipleMerchants': '所选店铺属于不同商户，请选择同一商户的店铺',
  'storeConfig.error.noPaymentSelected': '请至少选择一个支付配置',
  'storeConfig.error.attachPaymentFailed': '绑定支付信息失败',
  'storeConfig.error.detachPaymentFailed': '解除支付信息失败',
  'storeConfig.error.noTypeSelected': '请至少选择一个要解除的类型',
  'storeConfig.success.attachPaymentProfile': '绑定支付信息成功',
  'storeConfig.success.detachPaymentProfile': '解除支付信息成功',
  'storeConfig.modal.attachPaymentProfile': '绑定支付信息',
  'storeConfig.modal.detachPaymentProfile': '解除支付信息',
  'storeConfig.modal.cardConfig': '信用卡配置',
  'storeConfig.modal.scConfig': '续费信用卡配置',
  'storeConfig.modal.paypalConfig': 'PayPal配置',
  'storeConfig.modal.localPayment': '本地支付',
  'storeConfig.modal.selectPlaceholder': '请选择支付配置',
  'storeConfig.modal.selectTypes': '选择要解除的类型',
  'storeConfig.modal.detachWarning': '您选择的{count}个店铺下面的【{types}】将被解除',
};
